import { useEffect } from 'react';
import { attemptedActionStore } from 'helpers/attemptedActionStore';
import {
    AuthenticatedActions,
    AnyAuthenticatedUserAction,
    DownloadableItem,
} from 'types';

export const storeAttemptedDownloadAction = (
    downloadableItem: DownloadableItem,
) => {
    const attemptedDownload: AnyAuthenticatedUserAction = {
        type: AuthenticatedActions.downloadItem,
        args: [downloadableItem],
    };

    attemptedActionStore.set(attemptedDownload);
};

export const useStoreAttemptedDownloadAction = (
    downloadableItem: DownloadableItem | null | undefined,
    readyToStore: boolean,
) =>
    useEffect(() => {
        if (readyToStore && downloadableItem) {
            storeAttemptedDownloadAction(downloadableItem);
        }
    }, [readyToStore, downloadableItem]);
